import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ion-no-margin py-8 bold x-large"
}
const _hoisted_2 = {
  key: 1,
  "data-cy": "location-name",
  class: "ion-no-margin pb-8 bold location-name",
  style: {"font-size":"1.5em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_storeStatus = _resolveComponent("storeStatus")!
  const _component_ion_text = _resolveComponent("ion-text")!
  const _component_storeTime = _resolveComponent("storeTime")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_addressDisplay = _resolveComponent("addressDisplay")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_grid = _resolveComponent("ion-grid")!

  return (_openBlock(), _createElementBlock("div", {
    class: "mt-0",
    style: _normalizeStyle(_ctx.isMobile ? 'padding: 15px' : '')
  }, [
    (!_ctx.errorMsg && _ctx.storeLocation)
      ? (_openBlock(), _createBlock(_component_ion_grid, {
          key: 0,
          class: "ion-no-padding location-info",
          "data-cy": 'location-' + _ctx.storeLocation.slug,
          id: 'location-' + _ctx.storeLocation.slug
        }, {
          default: _withCtx(() => [
            (_ctx.isDeliveryTurnedOn && _ctx.isStoreOpen)
              ? (_openBlock(), _createBlock(_component_ion_row, {
                  key: 0,
                  "data-cy": "delivery-info",
                  class: "delivery-info ion-justify-content-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_col, {
                      size: "12",
                      class: "px-16"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_storeStatus, { storeLocation: _ctx.storeLocation }, null, 8, ["storeLocation"]),
                        _cache[3] || (_cache[3] = _createElementVNode("h5", { class: "ion-no-margin color-black estimated-title" }, [
                          _createElementVNode("strong", null, "Estimated Arrival Time:")
                        ], -1)),
                        (_ctx.storeLocation.storeStatus)
                          ? (_openBlock(), _createElementBlock("h2", _hoisted_1, [
                              _createVNode(_component_ion_text, {
                                color: "primary",
                                "data-cy": "location-delivery-delay"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.storeLocation.storeStatus.deliverydelay) + " - " + _toDisplayString(_ctx.storeLocation.storeStatus.deliverydelay + 5) + " minutes ", 1)
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.storeLocation?.name)
                          ? (_openBlock(), _createElementBlock("h5", _hoisted_2, "From " + _toDisplayString(_ctx.storeLocation.name), 1))
                          : _createCommentVNode("", true),
                        (_ctx.storeLocation)
                          ? (_openBlock(), _createBlock(_component_storeTime, {
                              key: 2,
                              storeLocation: _ctx.storeLocation,
                              showTodayHours: "",
                              class: "d-inline color-dark bold",
                              style: {"font-size":"1.2em"}
                            }, null, 8, ["storeLocation"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : (_ctx.isDeliveryTurnedOff)
                ? (_openBlock(), _createBlock(_component_ion_row, {
                    key: 1,
                    class: "ion-justify-content-center",
                    "data-cy": "delivery-unavailable"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        size: "10",
                        "size-md": "8"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_storeStatus, { storeLocation: _ctx.storeLocation }, null, 8, ["storeLocation"]),
                          _cache[5] || (_cache[5] = _createElementVNode("h4", { class: "my-0 color-black bold" }, "Delivery Unavailable", -1)),
                          _cache[6] || (_cache[6] = _createElementVNode("h5", { class: "my-8" }, "We currently cannot deliver to:", -1)),
                          _createVNode(_component_addressDisplay, {
                            address: _ctx.deliveryAddress,
                            "data-cy": "delivery-address",
                            dense: "",
                            showZip: ""
                          }, null, 8, ["address"]),
                          _cache[7] || (_cache[7] = _createElementVNode("h5", null, "Try another address or order pickup", -1)),
                          _createVNode(_component_ion_button, {
                            expand: "block",
                            color: "primary",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changePickup')))
                          }, {
                            default: _withCtx(() => _cache[4] || (_cache[4] = [
                              _createTextVNode("Order Pickup")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_ctx.isDeliveryTurnedOn && !_ctx.isStoreOpen)
                  ? (_openBlock(), _createBlock(_component_ion_row, {
                      key: 2,
                      class: "ion-justify-content-center",
                      "data-cy": "delivery-unavailable"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, {
                          size: "10",
                          "size-md": "8"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_storeStatus, { storeLocation: _ctx.storeLocation }, null, 8, ["storeLocation"]),
                            _cache[9] || (_cache[9] = _createElementVNode("h4", { class: "my-0 color-black bold" }, "This Donatos is closed right now.", -1)),
                            _cache[10] || (_cache[10] = _createElementVNode("h5", { class: "my-8" }, "We currently cannot deliver to:", -1)),
                            _createVNode(_component_addressDisplay, {
                              address: _ctx.deliveryAddress,
                              "data-cy": "delivery-address",
                              dense: "",
                              showZip: ""
                            }, null, 8, ["address"]),
                            _cache[11] || (_cache[11] = _createElementVNode("h5", null, "You can order ahead for a time when the restaurant is open.", -1)),
                            _createVNode(_component_ion_button, {
                              expand: "block",
                              color: "primary",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('deliverHere')))
                            }, {
                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                _createTextVNode("Order Ahead")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data-cy", "id"]))
      : (_ctx.errorMsg)
        ? (_openBlock(), _createBlock(_component_ion_grid, {
            key: 1,
            class: "ion-no-padding location-info",
            "data-cy": "location-error-card"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, {
                class: "ion-justify-content-center",
                "data-cy": "delivery-unavailable"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, {
                    size: "11",
                    "size-md": "8"
                  }, {
                    default: _withCtx(() => [
                      _cache[13] || (_cache[13] = _createElementVNode("h4", { class: "my-0 color-black bold" }, "Delivery Unavailable", -1)),
                      _cache[14] || (_cache[14] = _createElementVNode("h5", { class: "my-8" }, "We currently cannot deliver to:", -1)),
                      _createVNode(_component_addressDisplay, {
                        address: _ctx.deliveryAddress,
                        "data-cy": "delivery-address",
                        dense: "",
                        showZip: ""
                      }, null, 8, ["address"]),
                      _cache[15] || (_cache[15] = _createElementVNode("h5", null, "Try another address or order pickup", -1)),
                      _createVNode(_component_ion_button, {
                        expand: "block",
                        color: "primary",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('changePickup')))
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("Order Pickup")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
  ], 4))
}